import { useEffect, useState } from 'react'

/** 浏览器时区被改掉时（例如 DevTools Sensors）通知重新计算。墙钟 Date 不能跨时区缓存。 */
export function useTimezoneOffset() {
    const [offset, setOffset] = useState(() => new Date().getTimezoneOffset())

    useEffect(() => {
        const tick = () => {
            const next = new Date().getTimezoneOffset()
            setOffset(prev => (prev === next ? prev : next))
        }
        const id = window.setInterval(tick, 1000)
        window.addEventListener('focus', tick)
        return () => {
            window.clearInterval(id)
            window.removeEventListener('focus', tick)
        }
    }, [])

    return offset
}
